import React from "react";

function Footer() {
  return (
    <footer className="border-t border-border bg-card/50 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-2 mb-4 md:mb-0">
            <div className="w-6 h-6 bg-primary rounded border border-primary flex items-center justify-center">
              <span className="text-primary-foreground font-fira font-bold text-xs">
                DN
              </span>
            </div>
            <span className="font-fira text-foreground">DeveloperNoob</span>
          </div>

          <div className="text-center md:text-right">
            <p className="text-muted-foreground text-sm font-source">
              © {new Date()?.getFullYear()} DeveloperNoob. All bugs reserved.
            </p>
            <p className="text-muted-foreground text-xs font-source mt-1">
              Built with bugs, styled with hacks, powered by Noob 🚀
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
